import { api } from "../index";

export function getAssetDetailsByTagRequest({ config, tagId }) {
  return api.get(`/v1/asset/tag/${tagId}/details`, config);
}

export function getAssetRequest(config) {
  return api.get(`/v1/asset`, config);
}
